var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.670919 0.670919C1.10064 0.24133 1.68339 0 2.29101 0C2.89863 0 3.48138 0.24133 3.9111 0.670919L12.0138 8.77366L20.1166 0.670919C20.5488 0.253505 21.1276 0.0225345 21.7284 0.0277555C22.3292 0.0329765 22.904 0.273971 23.3288 0.698833C23.7537 1.1237 23.9947 1.69843 23.9999 2.29926C24.0051 2.90008 23.7742 3.47892 23.3567 3.9111L15.254 12.0138L23.3567 20.1166C23.7742 20.5488 24.0051 21.1276 23.9999 21.7284C23.9947 22.3292 23.7537 22.904 23.3288 23.3288C22.904 23.7537 22.3292 23.9947 21.7284 23.9999C21.1276 24.0051 20.5488 23.7742 20.1166 23.3567L12.0138 15.254L3.9111 23.3567C3.47892 23.7742 2.90008 24.0051 2.29926 23.9999C1.69843 23.9947 1.1237 23.7537 0.698833 23.3288C0.273971 22.904 0.0329765 22.3292 0.0277555 21.7284C0.0225345 21.1276 0.253505 20.5488 0.670919 20.1166L8.77366 12.0138L0.670919 3.9111C0.24133 3.48138 0 2.89863 0 2.29101C0 1.68339 0.24133 1.10064 0.670919 0.670919Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c4ac18bcecf6b1ccf9664f8424c2014d.svg";
export { ForwardRef as ReactComponent };